var map = {
	"./Curve.png": 451,
	"./arrowIcon.png": 452,
	"./bSwap-Icon.png": 453,
	"./backBTN.png": 184,
	"./binance-logo.png": 454,
	"./bnb-icon.png": 79,
	"./bnbRedioICON.png": 455,
	"./bnbSmallIcon.png": 456,
	"./bnbSmallIcon02.png": 457,
	"./cakeSmallIcon.png": 458,
	"./chains/chain-1.png": 162,
	"./chains/chain-10.png": 171,
	"./chains/chain-11.png": 172,
	"./chains/chain-12.png": 173,
	"./chains/chain-13.png": 174,
	"./chains/chain-14.png": 175,
	"./chains/chain-15.png": 176,
	"./chains/chain-16.png": 177,
	"./chains/chain-17.png": 178,
	"./chains/chain-18.png": 179,
	"./chains/chain-19.png": 180,
	"./chains/chain-2.png": 163,
	"./chains/chain-20.png": 181,
	"./chains/chain-21.png": 182,
	"./chains/chain-22.png": 183,
	"./chains/chain-3.png": 164,
	"./chains/chain-4.png": 165,
	"./chains/chain-5.png": 166,
	"./chains/chain-6.png": 167,
	"./chains/chain-7.png": 168,
	"./chains/chain-8.png": 169,
	"./chains/chain-9.png": 170,
	"./close-icon.png": 67,
	"./closeBTN.png": 58,
	"./coinicon-defiswap.png": 459,
	"./coinicon-miniswap.png": 460,
	"./coinicon-uniswap-v3.png": 461,
	"./coinicon-uniswap.png": 462,
	"./compound-finance.png": 463,
	"./cwICON-01.png": 185,
	"./cwICON-02.png": 186,
	"./cwICON-03.png": 187,
	"./cwICON-04.png": 188,
	"./darkLogo.png": 464,
	"./dex-mdex.png": 465,
	"./dex-shiba.png": 466,
	"./dex-wault.png": 467,
	"./dexIcon-01.png": 143,
	"./dexIcon-010.png": 152,
	"./dexIcon-011.png": 153,
	"./dexIcon-012.png": 154,
	"./dexIcon-013.png": 155,
	"./dexIcon-014.png": 156,
	"./dexIcon-015.png": 157,
	"./dexIcon-016.png": 158,
	"./dexIcon-017.png": 159,
	"./dexIcon-018.png": 160,
	"./dexIcon-019.png": 161,
	"./dexIcon-02.png": 144,
	"./dexIcon-03.png": 145,
	"./dexIcon-04.png": 146,
	"./dexIcon-05.png": 147,
	"./dexIcon-06.png": 148,
	"./dexIcon-07.png": 149,
	"./dexIcon-08.png": 150,
	"./dexIcon-09.png": 151,
	"./eth-icon.png": 103,
	"./ethRedioICON.png": 468,
	"./etherLOGO.png": 469,
	"./ethereum-logo.png": 470,
	"./exclamation.png": 471,
	"./fighter-icon.png": 472,
	"./footerLink_icon.png": 473,
	"./ftmIcon.png": 474,
	"./logo-icon.png": 475,
	"./logo-without-text.png": 476,
	"./logo.png": 477,
	"./mainbg01.png": 241,
	"./mdex-icon.png": 478,
	"./metamask.png": 479,
	"./mngTokenICO-01.png": 480,
	"./mngTokenICO-02.png": 481,
	"./mngTokenICO-03.png": 482,
	"./mngTokenICO-04.png": 483,
	"./page1.png": 484,
	"./page10.png": 485,
	"./page11.png": 486,
	"./page12.png": 487,
	"./page13.png": 488,
	"./page14.png": 489,
	"./page15.png": 490,
	"./page16.png": 491,
	"./page17.png": 492,
	"./page18.png": 493,
	"./page19.png": 494,
	"./page2.png": 495,
	"./page20.png": 496,
	"./page21.png": 497,
	"./page22.png": 498,
	"./page24.png": 499,
	"./page25.png": 500,
	"./page26.png": 501,
	"./page28.png": 502,
	"./page29.png": 503,
	"./page3.png": 504,
	"./page31.png": 505,
	"./page32.png": 506,
	"./page33.png": 507,
	"./page34.png": 508,
	"./page35.png": 509,
	"./page36.png": 510,
	"./page37.png": 511,
	"./page38.png": 512,
	"./page39.png": 513,
	"./page4.png": 514,
	"./page40.png": 515,
	"./page41.png": 516,
	"./page42.png": 517,
	"./page43.png": 518,
	"./page44.png": 519,
	"./page45.png": 520,
	"./page46.png": 521,
	"./page47.png": 522,
	"./page48.png": 523,
	"./page49.png": 524,
	"./page5.png": 525,
	"./page50.png": 526,
	"./page51.png": 527,
	"./page52.png": 528,
	"./page53.png": 529,
	"./page54.png": 530,
	"./page55.png": 531,
	"./page56.png": 532,
	"./page57.png": 533,
	"./page58.png": 534,
	"./page59.png": 535,
	"./page60.png": 536,
	"./page61.png": 537,
	"./page62.png": 538,
	"./page7.png": 539,
	"./page8.png": 540,
	"./page9.png": 541,
	"./ploygon-logo.png": 542,
	"./polygon.png": 543,
	"./selectTkn-01.png": 544,
	"./selectTkn-02.png": 545,
	"./selectTkn-03.png": 546,
	"./selectTkn-04.png": 547,
	"./selectTkn-05.png": 548,
	"./selectTkn-06.png": 549,
	"./selectTkn-07.png": 550,
	"./selectTkn-08.png": 551,
	"./serum-dex.png": 552,
	"./shibaswap-icon.png": 553,
	"./smBNB-icon.png": 554,
	"./spookyswap.png": 555,
	"./swapBICON-01.png": 556,
	"./swapBICON-02.png": 557,
	"./swapSICON-01.png": 558,
	"./swapSICON-02.png": 559,
	"./swapTitleIcon-01.png": 560,
	"./swapTitleIcon-02.png": 561,
	"./swapTitleIcon-03.png": 562,
	"./swapTitleIcon-04.png": 563,
	"./tableICON-01.png": 564,
	"./tableICON-010.png": 565,
	"./tableICON-011.png": 566,
	"./tableICON-02.png": 567,
	"./tableICON-03.png": 568,
	"./tableICON-04.png": 569,
	"./tableICON-05.png": 570,
	"./tableICON-06.png": 571,
	"./tableICON-07.png": 572,
	"./tableICON-08.png": 573,
	"./tableICON-09.png": 574,
	"./tenex.png": 114,
	"./traderjoe.png": 575,
	"./unicornIco.png": 141,
	"./wault-icon.png": 576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 450;